import LegalPage from "./LegalPage";

export default function TermsPage() {
  return (
    <LegalPage
      eyebrow="Legal · The Philosopher Test"
      title="Terms of Service"
      updated="July 20, 2026"
      testid="terms-screen"
      path="/terms"
      metaDescription="Terms of Service for The Philosopher Test — the free 20-question philosopher personality quiz and its optional $9.99 Full Report."
    >
      <h2>1. Who we are</h2>
      <p>
        The Philosopher Test (&ldquo;we&rdquo;, &ldquo;us&rdquo;, the &ldquo;Service&rdquo;) is an
        online personality quiz that produces a philosopher-match result and, optionally, a paid
        personalized report. You can reach us at{" "}
        <a href="mailto:contact@thephilosophertest.com">contact@thephilosophertest.com</a>.
      </p>

      <h2>2. Using the Service</h2>
      <p>
        You may take the free quiz and view your result without creating an account. By using the
        Service you confirm that you are at least 16 years old (or the age of digital consent in
        your country) and that you are using the Service in good faith.
      </p>
      <p>
        The Service is intended for entertainment and self-reflection. It is not a diagnostic,
        clinical, therapeutic, medical, or scientific instrument. Do not use it to make
        decisions that would normally require professional advice.
      </p>

      <h2>3. The Full Report (paid product)</h2>
      <p>
        The Full Report is a one-time digital product priced at USD $9.99. Payment is processed
        by Stripe. Once you complete payment, we generate your report using an AI language model
        and deliver it via (a) an on-screen private link on the success page and (b) an email to
        the address you provided at checkout. You are responsible for saving the private link if
        the email is filtered or lost.
      </p>
      <p>
        See our <a href="/refunds">Refund Policy</a> for information on cancellations and
        refunds.
      </p>

      <h2>4. Your content and your rights</h2>
      <p>
        The quiz answers and traits you generate belong to you. You grant us a limited licence to
        process them solely to compute your match, generate your report, and — if you provided an
        email — send you your result. See our <a href="/privacy">Privacy Policy</a> for details.
      </p>

      <h2>5. Our content</h2>
      <p>
        The quiz questions, philosopher profiles, the marble &amp; gold visual design, the share
        card layout, and the report copy are the intellectual property of the Service. You may
        share your result card and your report freely for personal purposes. You may not resell,
        systematically scrape, or reproduce the Service or its outputs as a competing product.
      </p>

      <h2>6. Availability &amp; changes</h2>
      <p>
        We do our best to keep the Service running but we do not guarantee uninterrupted
        availability. We may update the quiz, the report format, or these Terms at any time. If
        we make a material change, we will indicate it here with a new &ldquo;Last updated&rdquo;
        date.
      </p>

      <h2>7. Liability</h2>
      <p>
        To the maximum extent permitted by law, the Service is provided &ldquo;as is&rdquo; and
        our aggregate liability to you is limited to the amount you paid us in the twelve months
        preceding the claim (i.e. up to USD $9.99 for a single Full Report purchase).
      </p>

      <h2>8. Governing law &amp; contact</h2>
      <p>
        These Terms are governed by French law. If you have any question or complaint, write to{" "}
        <a href="mailto:contact@thephilosophertest.com">contact@thephilosophertest.com</a> and we
        will respond in good faith.
      </p>

      <h2>Legal notice</h2>
      <p>
        <strong>Publisher:</strong> Mendola Jonathan (sole proprietor / entrepreneur individuel).
        <br />
        <strong>Registration:</strong> RCS Paris 924 119 449 — SIRET 924 119 449 00032.
        <br />
        <strong>Business address:</strong> 47 rue Vivienne, 75002 Paris, France.
        <br />
        <strong>Contact:</strong>{" "}
        <a href="mailto:contact@thephilosophertest.com">contact@thephilosophertest.com</a>.
        <br />
        <strong>Hosting:</strong> Emergent Labs Inc., 2380 Via Espada, Pleasanton, CA 94566, USA
        — <a href="mailto:support@emergent.sh">support@emergent.sh</a>.
      </p>
    </LegalPage>
  );
}
